import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./page-header.scss";
import { getBackgroundCssFromRenditions } from "../../styles/CssInJsHelpers";

const PageHeader = ({
  pageTitle,
  quote,
  backgroundImages,
  className,
  children,
  quoteAdditional,
  quoteFontSize,
  ...props
}) => {
  const withBackground = !!backgroundImages && backgroundImages.length;
  const classes = classnames(
    "page-header",
    {
      "page-header--with-background": withBackground,
    },
    className
  );

  return (
    <div
      className={classes}
      css={withBackground ? getBackgroundCssFromRenditions(backgroundImages) : {}}
      {...props}
    >
      {!!withBackground && <div className="page-header__background-overlay" />}
      <header className="page-header__content">
        <div className="grid-container fluid">
          <div className="cell">
            <h1>
              {pageTitle && (
                <div className="page-header__title u-content-container-medium">{pageTitle}</div>
              )}
              {quote && (
                <div className="page-header__quote">
                  <div
                    className={`page-header__quote-inner u-font-heading ${quoteFontSize} u-content-container-medium`}
                  >
                    {quote}
                  </div>
                  {quoteAdditional && (
                    <div className="page-header__quote-inner">{quoteAdditional}</div>
                  )}
                </div>
              )}
            </h1>
          </div>
        </div>
      </header>
      {children && (
        <div className="page-header__extra-content">
          <div className="grid-container fluid">
            <div className="cell">{children}</div>
          </div>
        </div>
      )}
    </div>
  );
};

PageHeader.defaultProps = {
  quoteFontSize: "h500",
};

PageHeader.propTypes = {
  /**
   * Custom className to add to the component
   */
  className: PropTypes.string,
  /**
   * Line of text to be added at the top as an overheading
   */
  pageTitle: PropTypes.string,
  /**
   * Sets font size of quote text
   */
  quoteFontSize: PropTypes.oneOf(["h500", "h300"]),
  /**
   * Large font message
   */
  quote: PropTypes.string,
  /**
   * Additional element displayed next to quote
   */
  quoteAdditional: PropTypes.node,
  /**
   * Background images
   */
  backgroundImages: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      minWidth: PropTypes.number,
      maxWidth: PropTypes.number,
    })
  ),
  /**
   * Content to be rendered beneath the text
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PageHeader;
